import Container from '../../../components/Container'
import { Layout } from '@staccx/bento'
import { TranslatedText } from '@staccx/i18n'
import { ConsolidateInvoiceSelect } from '../../../components/menu/ConsolidateInvoiceSelect'
import ReportTermSelect from '../components/ReportTermSelect'
import { useUser, useUserContext } from '../../../context/UserProvider'
import { useQuery } from 'react-query'
import { fetchMileageReport } from '../../../api/api'
import { fetchFleetReportTerms } from '../../../api/newApi'
import MileageReportTable from '../components/MileageTables/MileageReportTable'
import { useFilterOnConsolidateAgreement } from '../hooks/useFilterOnConsolidateAgreement'
import { RightAlignedRow } from '../../../theme/Theme.ItemGroup'
import ExcelButton from '../components/ExcelButton'
import getLastDateInMonth from '../../../utils/getLastDateInMonth'
import { Heading } from '../../../components/text/Headings'

const MileageReport = () => {
  const { chosenCompany: company, fleetReportTerm } = useUserContext()
  const companyId = company?.id
  const contactId = useUser()?.user?.id
  const { data: termsResponse } = useQuery(
    ['fleetReportTerms', companyId, contactId],
    () => fetchFleetReportTerms({ companyId, contactId, fetchAll: true }),
    {
      enabled: !!companyId && !!contactId,
    },
  )
  const terms = termsResponse?.items?.map(({ termPeriod }) => termPeriod) || []

  const { data = [], status } = useQuery(
    ['mileageReport', companyId, fleetReportTerm],
    () => fetchMileageReport(companyId, fleetReportTerm, getLastDateInMonth(fleetReportTerm)),
    {
      enabled: !!companyId,
    },
  )

  const agreementFilter = useFilterOnConsolidateAgreement()

  return (
    <Container width="unlimited">
      <Layout rowGap={'large'}>
        <TranslatedText i18nKey={'MILEAGE_REPORT_MENUITEM'}>{(value) => <Heading>{value}</Heading>}</TranslatedText>
        <Layout variant="fiftyFifty">
          <TranslatedText i18nKey="TERM">
            {(value) => <ReportTermSelect label={value} reportTerms={terms} />}
          </TranslatedText>
          <ConsolidateInvoiceSelect />
        </Layout>
      </Layout>
      <RightAlignedRow>
        <ExcelButton />
      </RightAlignedRow>
      <MileageReportTable
        data={data
          .filter(agreementFilter('ConsolidatedInvoiceNo'))
          .filter((obj, index, self) => index === self.findIndex((t) => t.AccountNo === obj.AccountNo))}
        isLoading={status === 'loading'}
      />
    </Container>
  )
}

export default MileageReport
